var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-wrapper"},[_c('img',{ref:"printImage",staticClass:"print-img",attrs:{"src":_vm.prescriptionImg,"alt":""},on:{"load":_vm.print}})])
}
var staticRenderFns = []

export { render, staticRenderFns }